import React from 'react';
import { CancellationPolicy } from 'AppClient/api/Bookings/BokkingsTypes';
import { FormattedMinutesText } from './FormattedMinutesText';
import { isNil } from 'lodash-es';

interface Props {
	data: CancellationPolicy[] | null;
	customerCurrencySymbol: string;
}
export const CancellationPolicyTCText: React.FC<Props> = props => {
	const { data } = props;

	const getTitle = () => <h5>Cancellation policy</h5>;

	const getContent = () => {
		if (!data) {
			return emptyContent();
		}

		return fullContent(data);
	};

	const emptyContent = () => <p>There is no cancellation policy.</p>;

	const getCharged = (item: CancellationPolicy) => {
		const { customerCurrencySymbol } = props;
		const { chargedPercentages, fixedCancellationFeeInCustomerCurrency } = item;
		let chargedText = '';

		if (!isNil(chargedPercentages)) {
			chargedText = `${chargedPercentages}%`;
		} else if (!isNil(fixedCancellationFeeInCustomerCurrency)) {
			chargedText = `${fixedCancellationFeeInCustomerCurrency}${customerCurrencySymbol}`;
		}

		return chargedText;
	};

	const fullContent = (data: CancellationPolicy[]) => {
		return (
			<div>
				{data.map((item,index) => {
					return (
						<p key={`${item.chargedPercentages}-${index}`}>
							You will be charged <strong>{getCharged(item)}</strong> of your
							reservation if this is cancelled from{' '}
							<strong>
								{item.fromMinutes} <FormattedMinutesText value={item.fromMinutes} />{' '}
								to {item.toMinutes} <FormattedMinutesText value={item.toMinutes} />
							</strong>{' '}
							prior to pick up time.
						</p>
					);
				})}
			</div>
		);
	};

	return (
		<>
			{getTitle()}
			{getContent()}
		</>
	);
};
